
import { companyInfo } from '@/data/companyInfo';
import { removeExistingSchema, addSchemaToHead } from '@/utils/seoUtils';

export const addRockyMountSchema = () => {
  removeExistingSchema();
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    "name": companyInfo.name,
    "url": companyInfo.url,
    "logo": companyInfo.logo,
    "image": `${companyInfo.url}/images/hero.jpg`,
    "description": `${companyInfo.name} is the top-rated roofing contractor serving Rocky Mount, NC and surrounding areas. We provide expert residential and commercial roofing services including asphalt shingles, metal roofs, TPO, membrane systems, coatings, slate, and storm damage restoration. Known for high-end results, fast turnaround, and emergency leak tarping across Eastern NC.`,
    "telephone": "+1-252-302-2003",
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.address.streetAddress,
      "addressLocality": companyInfo.address.addressLocality,
      "addressRegion": companyInfo.address.addressRegion,
      "postalCode": companyInfo.address.postalCode,
      "addressCountry": companyInfo.address.addressCountry
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": companyInfo.locationGeo.rockyMount.latitude,
      "longitude": companyInfo.locationGeo.rockyMount.longitude
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "07:00",
        "closes": "19:00"
      }
    ],
    "sameAs": companyInfo.sameAs,
    "serviceArea": {
      "@type": "Place",
      "name": "Rocky Mount, NC"
    },
    "award": companyInfo.awards,
    "contactPoint": [{
      "@type": "ContactPoint",
      "telephone": "+1-252-302-2003",
      "areaServed": "Rocky Mount",
      "contactType": "customer service",
      "availableLanguage": "English"
    }]
  };
  
  addSchemaToHead(schema);
};

export const addGreenvilleSchema = () => {
  removeExistingSchema();
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    "name": companyInfo.name,
    "url": companyInfo.url,
    "logo": companyInfo.logo,
    "image": `${companyInfo.url}/images/hero.jpg`,
    "description": `${companyInfo.name} is the top-rated roofing contractor serving Greenville, NC and surrounding areas. We provide expert residential and commercial roofing services including asphalt shingles, metal roofs, TPO, membrane systems, coatings, slate, and storm damage restoration. Known for high-end results, fast turnaround, and emergency leak tarping across Eastern NC.`,
    "telephone": "+1-252-371-2266",
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.greenvilleAddress.streetAddress,
      "addressLocality": companyInfo.greenvilleAddress.addressLocality,
      "addressRegion": companyInfo.greenvilleAddress.addressRegion,
      "postalCode": companyInfo.greenvilleAddress.postalCode,
      "addressCountry": companyInfo.greenvilleAddress.addressCountry
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": companyInfo.locationGeo.greenville.latitude,
      "longitude": companyInfo.locationGeo.greenville.longitude
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "07:00",
        "closes": "19:00"
      }
    ],
    "sameAs": companyInfo.sameAs,
    "serviceArea": {
      "@type": "Place",
      "name": "Greenville, NC"
    },
    "award": companyInfo.awards,
    "contactPoint": [{
      "@type": "ContactPoint",
      "telephone": "+1-252-371-2266",
      "areaServed": "Greenville",
      "contactType": "customer service",
      "availableLanguage": "English"
    }]
  };
  
  addSchemaToHead(schema);
};

export const addTarboroSchema = () => {
  removeExistingSchema();
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    "name": companyInfo.name,
    "url": companyInfo.url,
    "logo": companyInfo.logo,
    "image": `${companyInfo.url}/images/hero.jpg`,
    "description": `${companyInfo.name} is the top-rated roofing contractor serving Tarboro, NC and surrounding areas. We provide expert residential and commercial roofing services including asphalt shingles, metal roofs, TPO, membrane systems, coatings, slate, and storm damage restoration. Known for high-end results, fast turnaround, and emergency leak tarping across Eastern NC.`,
    "telephone": "+1-252-302-2003",
    "email": companyInfo.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": companyInfo.tarboroAddress.streetAddress,
      "addressLocality": companyInfo.tarboroAddress.addressLocality,
      "addressRegion": companyInfo.tarboroAddress.addressRegion,
      "postalCode": companyInfo.tarboroAddress.postalCode,
      "addressCountry": companyInfo.tarboroAddress.addressCountry
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": companyInfo.locationGeo.tarboro.latitude,
      "longitude": companyInfo.locationGeo.tarboro.longitude
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "07:00",
        "closes": "19:00"
      }
    ],
    "sameAs": companyInfo.sameAs,
    "serviceArea": {
      "@type": "Place",
      "name": "Tarboro, NC"
    },
    "award": companyInfo.awards,
    "contactPoint": [{
      "@type": "ContactPoint",
      "telephone": "+1-252-302-2003",
      "areaServed": "Tarboro",
      "contactType": "customer service",
      "availableLanguage": "English"
    }]
  };
  
  addSchemaToHead(schema);
};

export const addFAQSchema = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you serve both Rocky Mount and Greenville?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we have teams based in both Rocky Mount and Greenville, NC. We also cover the surrounding counties and towns throughout Eastern North Carolina including Wilson, Zebulon, Tarboro, and Nashville."
        }
      },
      {
        "@type": "Question",
        "name": "What roofing systems do you offer?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We install architectural shingles, metal roofing, flat roofing (TPO, EPDM), roof coatings, slate, and more. Our crews are trained for both residential and commercial projects with full licensing and insurance."
        }
      },
      {
        "@type": "Question",
        "name": "Do you help with insurance claims?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! We specialize in storm damage restoration and work directly with insurance companies. We provide detailed documentation, meet with adjusters, and help navigate the entire claims process."
        }
      },
      {
        "@type": "Question",
        "name": "How quickly can you respond to emergency repairs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We offer 24/7 emergency response for roof leaks and storm damage. Our emergency tarping service can protect your property within hours of your call."
        }
      },
      {
        "@type": "Question",
        "name": "What areas do you serve in Eastern North Carolina?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We serve Rocky Mount, Greenville, Wilson, Zebulon, Tarboro, Nashville, and all surrounding areas in Eastern NC. With offices in Rocky Mount and Greenville, we provide fast local service."
        }
      },
      {
        "@type": "Question",
        "name": "Can I see examples of your recent work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Of course! Visit our Gallery page to see completed roofing projects throughout Eastern NC. We showcase residential and commercial work with before/after photos."
        }
      }
    ]
  };
  
  addSchemaToHead(faqSchema);
};

export const addOrganizationSchema = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": companyInfo.name,
    "url": companyInfo.url,
    "logo": companyInfo.logo,
    "description": "Carolina Trophy Roofs is Eastern North Carolina's premier roofing contractor, serving Rocky Mount, Greenville, Wilson, and surrounding areas since 2010. We specialize in residential and commercial roofing services.",
    "foundingDate": "2010",
    "areaServed": {
      "@type": "State",
      "name": "North Carolina"
    },
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": companyInfo.address.streetAddress,
        "addressLocality": companyInfo.address.addressLocality,
        "addressRegion": companyInfo.address.addressRegion,
        "postalCode": companyInfo.address.postalCode,
        "addressCountry": companyInfo.address.addressCountry
      },
      {
        "@type": "PostalAddress",
        "streetAddress": companyInfo.greenvilleAddress.streetAddress,
        "addressLocality": companyInfo.greenvilleAddress.addressLocality,
        "addressRegion": companyInfo.greenvilleAddress.addressRegion,
        "postalCode": companyInfo.greenvilleAddress.postalCode,
        "addressCountry": companyInfo.greenvilleAddress.addressCountry
      }
    ],
    "contactPoint": companyInfo.contactPoints,
    "sameAs": companyInfo.sameAs,
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": companyInfo.reviews.length.toString(),
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": companyInfo.reviews.map(review => ({
      "@type": "Review",
      "author": { "@type": "Person", "name": review.author },
      "reviewRating": { "@type": "Rating", "ratingValue": review.rating, "bestRating": "5" },
      "reviewBody": review.reviewBody
    }))
  };
  
  addSchemaToHead(organizationSchema);
};

// Add Service schema for better service page SEO
export const addServiceSchema = (serviceName: string, serviceDescription: string) => {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": serviceName,
    "description": serviceDescription,
    "provider": {
      "@type": "RoofingContractor",
      "name": companyInfo.name,
      "telephone": "+1-252-302-2003",
      "email": companyInfo.email,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": companyInfo.address.streetAddress,
        "addressLocality": companyInfo.address.addressLocality,
        "addressRegion": companyInfo.address.addressRegion,
        "postalCode": companyInfo.address.postalCode,
        "addressCountry": companyInfo.address.addressCountry
      }
    },
    "areaServed": [
      { "@type": "City", "name": "Rocky Mount, NC" },
      { "@type": "City", "name": "Greenville, NC" },
      { "@type": "City", "name": "Wilson, NC" },
      { "@type": "City", "name": "Zebulon, NC" },
      { "@type": "City", "name": "Tarboro, NC" },
      { "@type": "City", "name": "Nashville, NC" }
    ],
    "serviceType": "Roofing Services",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Roofing Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Roof Replacement",
            "description": "Complete roof replacement with premium materials and expert installation."
          }
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "Roof Repair",
            "description": "Professional roof repair services for leaks, storm damage, and general maintenance."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service", 
            "name": "Storm Damage Restoration",
            "description": "Emergency response and complete restoration for storm-damaged roofs."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Insurance Claims Assistance", 
            "description": "Expert help navigating insurance claims for roof damage."
          }
        }
      ]
    }
  };
  
  addSchemaToHead(serviceSchema);
};

// Add BreadcrumbList schema for navigation
export const addBreadcrumbSchema = (breadcrumbs: Array<{name: string, url: string}>) => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": `${companyInfo.url}${crumb.url}`
    }))
  };
  
  addSchemaToHead(breadcrumbSchema);
};
